import { FormSwitch } from '@ipfabric/ui-components/FormSwitch/FormSwitch';
import type { Control } from 'react-hook-form';
import type { AssignLabelsFormSchemaValues } from './AssignLabelsForm/assignLabelsFormSchema';
import {
  REFLECT_TO_RULES_HELPER,
  REFLECT_TO_RULES_LABEL,
} from './ReflectToRulesSwitch';

type ReflectToRulesFormSwitchProps = {
  control: Control<AssignLabelsFormSchemaValues>;
};

export const ReflectToRulesFormSwitch = ({
  control,
}: ReflectToRulesFormSwitchProps) => (
  <div data-testid='reflect-to-rules-switch'>
    <FormSwitch<AssignLabelsFormSchemaValues>
      control={control}
      label={REFLECT_TO_RULES_LABEL}
      labelTooltip={REFLECT_TO_RULES_HELPER}
      name='reflectToRules'
    />
  </div>
);
